import C from '../../Resume.module.scss';
import S from './SelfIntroductionEdit.module.scss';
import {ResumeTabsType, ResumeType} from '../../../../../types/ResumeTypes';
import {Dispatch, SetStateAction} from "react";

interface SelfIntroductionEditProps {
  selfIntroduction: string;
  resumeTabs: ResumeTabsType;
  setResume: Dispatch<SetStateAction<ResumeType>>;
}

const SelfIntroductionEdit = (props: SelfIntroductionEditProps) => {
  const { resumeTabs, setResume, selfIntroduction } = props;

  const updateSelfIntroduction = (content: string) => {
    setResume((prev) => ({...prev, selfIntroduction: content}));
  }

  return (
    <>
      <section
        ref={resumeTabs[4].element}
        className={`${C.basic_edit_section} wrapper ${S.self_intro_section}`}
      >
        <h4 className={`${C.basic_edit_title} h4`}>자기소개서</h4>
        <div className={C.basic_wrap}>
          <div className={C.basic_title}>
            <p className="b1">자기소개</p>
          </div>
          <div className={C.basic_wrap}>
            <div
              className={`${C.basic_edit_input} ${C.resume_textarea} input-grp input-textarea-height`}
            >
              <label htmlFor="selfIntroduction" className="textarea-label focus-on">
                상세내용
              </label>
              <textarea
                id="selfIntroduction"
                className={`input-text input-border ${S.self_textarea}`}
                placeholder="500자 이내로 작성해주세요."
                value={selfIntroduction || ''}
                maxLength={500}
                onChange={(e) => {
                  updateSelfIntroduction(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <hr />
    </>
  );
};

export default SelfIntroductionEdit;
